// extracted by mini-css-extract-plugin
export default {"card":"vY-z","carouselContainer":"wY-z","carouselContent":"xY-z"};